// TODO(Sergio): Temporary skip eslint rules, this is part of the A6-A12 migration from mono-frontend
/* eslint-disable  */
import { Injectable } from '@angular/core';
import { DateOfBirth } from '../data-models/common.interfaces';

@Injectable({
  providedIn: 'root'
})
export class ValidatorService {
  static propertyExist<T>(
    object: T,
    property: keyof T,
    content: string
  ): boolean {
    return (
      (object[property] as unknown as string).toLowerCase() ===
      content.toLowerCase()
    );
  }

  /**
   * Helps to validate if two dependant values exist
   * This utility helps to reduce cyclomatic complexity
   * You can see how to use it on the Fast Action Banner library
   */
  static valuesExist<T>(status: boolean, content: T, turn = true): boolean {
    let result: boolean = turn ? status : !status;

    if (result && content) {
      result = true;
    } else {
      result = false;
    }

    return result;
  }

  /** Generic method to identify presence of children attributes  */
  static childrenExist<T>(object: T, ...children: string[]): boolean {
    let tempObject = object;
    return !children
      // @ts-ignore
      .map((property) => {
        // @ts-ignore
        if (!(tempObject && tempObject[property])) {
          return false;
        }
        // @ts-ignore
        tempObject = tempObject[property];
      })
      .includes(false);
  }

  validateAge(
    dateOfBirth: DateOfBirth,
    ageNumber: number,
    yearAgeCalculation: number
  ) {
    const { year, month, date } = dateOfBirth;
    const birthday: Date = new Date(year, month, date);
    const age = new Date(Date.now() - birthday.getTime());
    if (Math.abs(age.getUTCFullYear() - yearAgeCalculation) < ageNumber) {
      return true;
    } else {
      return false;
    }
  }
}
